<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang = "scss">

/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
    width: 6px; /*对垂直流动条有效*/
    height: 6px; /*对水平流动条有效*/
}
 
/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
    border-radius: 4px;
    /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
    /* background-color: rosybrown; */
}
 
/*定义滑块颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb{
    border-radius: 8px;
    background-color: #DDDEE0;
    /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
}
 
/*定义滑块悬停变化颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb:hover{
    background-color: #C7C9CC;
}
 
/*定义两端按钮的样式*/
::-webkit-scrollbar-button {
    /* background-color: cyan; */
}
 
/*定义右下角汇合处的样式*/
::-webkit-scrollbar-corner {
    /* background: khaki; */
}
 
/* 隐藏滚动条 */
/* ::-webkit-scrollbar {
    display: none;
} */

.el-card {
  height: 100%;
}
.judImg {
  position: absolute;
  top: 50%;
  right: 10%;
  transform: translateY(-50%);
}
.el-empty__image {
  width: 490px !important;
}
.el-empty__description p {
  font-size: 18px;
}
img.car {
  border: 1px solid #dedede;
  width: 100% !important;
  height: 1.4rem !important;
  background: #eeeeee;
  box-sizing: border-box;
  border-radius: 0.05rem;
}

.car {
  border: 1px solid #dedede;
  width: 100% !important;
  height: 1.4rem !important;
  background: #eeeeee;
  box-sizing: border-box;
  border-radius: 0.05rem;
}

.thumImg {
  width: 1.6rem;
  height: 1rem;
  margin: 0.05rem;
  object-fit: cover;
  cursor: pointer;
}
.pages {
  margin-top: 0.15rem;
}
.pages > div:first-child {
  margin-top: 0;
}
.el-form-item__label,
.el-table {
  font-size: 0.14rem;
}
.filter .el-select .el-input__inner {
  width: 1.2rem;
}
.el-pagination__jump {
  margin-left: 0;
}
.el-date-editor .el-range-separator {
  padding: 0 !important;
  width: 7% !important;
}
.el-tabs--card > .el-tabs__header {
  border: none;
  margin-bottom: 0;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none !important;
  padding-top: 0.03rem;
}
.el-tabs--card > .el-tabs__header .el-tabs__item {
  margin-right: 0.1rem;
  background: #f5f5f5;
  border-top-left-radius: 0.03rem;
  border-top-right-radius: 0.03rem;
  color: #666666;
  box-shadow: 0px 0px 3px #d9d9d9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(1) {
  margin-left: 0.01rem;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #56adfd;
  color: #ffffff;
}
.box-card .title {
  font-size: 0.18rem;
}

.tabsRight .el-tabs__nav {
  float: right;
}
.mini .el-tabs__item {
  height: 26px;
  line-height: 26px;
}
.mini .el-tabs__header {
  margin-bottom: 0;
}
.noMove .el-slider__button-wrapper {
  display: none;
}
.noMove .el-slider__bar {
  border-radius: 20px;
  height: 0.1rem;
}
.noMove .el-slider__runway {
  margin: 0;
  height: 0.1rem;
  border-radius: 20px;
}
.el-dialog__body {
  // max-height: 60vh;
  overflow-y: scroll;
}
.el-dialog__body::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 5px;
  height: 5px;
}
/*.el-dialog__body::-webkit-scrollbar-button{!*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*!*/
/*background:#fff;*/
/*}*/
.el-dialog__body::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  background: #f8f9fa;
}
.el-dialog__body::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  background: #f8f9fa;
}
.el-dialog__body::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #00000033;
  border-radius: 4px;
}
.el-dialog__body::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #eee;
}
/*#scroll::-webkit-scrollbar-resizer  {!*定义右下角拖动块的样式（位置7）*!*/
/*background:#FF0BEE;*/
/*}*/
.el-dialog__body {
  scrollbar-arrow-color     : #f4ae21; /**/  /*三角箭头的颜色*/
  scrollbar-face-color      : #333; /**/     /*立体滚动条的颜色*/
  scrollbar-3dlight-color   : #666; /**/     /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color : #666; /**/     /*滚动条空白部分的颜色*/
  scrollbar-shadow-color    : #999; /**/     /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666; /**/     /*立体滚动条强阴影的颜色*/
  scrollbar-track-color     : #666; /**/     /*立体滚动条背景颜色*/
  scrollbar-base-color      : #f8f8f8; /**/  /*滚动条的基本颜色*/
}

.el-dialog {
  margin-top: 50vh !important;
  transform: translateY(-50%) !important;
}
.el-dialog__wrapper {
  bottom: auto;
}
.el-dialog__headerbtn .el-dialog__close {
  font-size: 0.3rem;
}
*{
  // user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue